import React from 'react'
import { StepSubmit } from './Components'
import { badaPropTypes, badaDefaultProps } from '../../../../types'
import tracker from '../../../../utils/tracker'

const SubmitStep = ({
  props: {
    badaProps: { overrideMeetingType },
    wizard: {
      step: { two, three, four },
    },
    selectedStore,
    selectedSlot,
    selectedService,
    updateUiState,
    values,
    previousQuestions,
    history,
    flow,
    appointment,
    selectedServiceProvider,
  },
}) => (
  <StepSubmit
    show={four}
    props={{
      selectedSlot,
      selectedStore,
      selectedService,
      values,
      previousQuestions,
      updateUiState,
      overrideMeetingType,
      onUpdate: () => {},
      onMount: () => {
        tracker.trackPageview('BADA 2.0 dataform', '/bada/step-3', { flow })
        if (!two && !three) {
          tracker.trackAuto(
            'BADA 2.0 meeting type',
            selectedStore.acceptMeetings
              ? `singletype store - ${selectedStore.name}`
              : `singletype home - ${selectedStore.name}`,
            { flow }
          )
        }
      },
      addHistory: (id, storeid) => {
        const separator = window.location.search ? '&' : '?'
        const notRepeatVisitByEmail = 'visit=first'
        history.push(
          `${window.location.search}${separator}appointment=${id}&studioid=${storeid}&${notRepeatVisitByEmail}#complete`,
          { bookingCompleted: false }
        )
      },
      flow,
      appointment,
      selectedServiceProvider,
    }}
  />
)

SubmitStep.propTypes = {
  ...badaPropTypes,
}

SubmitStep.defaultProps = {
  ...badaDefaultProps,
}

export default SubmitStep
